<template>
  <div class="radio fRow jStart aCenter transition-fast"
    v-bind:class="{
      selected: selected,
      deselected: !selected,
      simpled: simple,
      disable: disabled,
      noSlot: !hasSlot || hasSlot === undefined,
    }">
    <div class="indicator deselected fCol jCenter aCenter transition-fast"
      v-if="checkbox === undefined || checkbox === false">
      <div class="activeCirc transition-fast"></div>
    </div>
    <div class="indicator checkbox deselected fCol jCenter aCenter transition-fast"
      v-if="checkbox">
      <div class="activeCirc transition-fast"></div>
    </div>
    <div class="fCol growFull jCenter aStart" v-if="!hasSlot">
      <div class="mainLabel">{{data.title}}</div>
      <div class="descLabel"
        v-if="data.desc !== undefined && !simple">
        {{data.desc}}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['data', 'selected', 'simple', 'disabled', 'hasSlot', 'checkbox'],
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
* {
  user-select: none;
}
.radio {
  padding: 16px;
  border-radius: 16px;
  cursor: pointer;
  $ww: 24px;
  border: solid 4px;
  .indicator {
    width: $ww;
    height: $ww;
    min-width: $ww;
    border-radius: 50%;
    border: solid 4px;
    margin-left: 16px;
    .activeCirc {
      border-radius: 50%;
      background-color: var(--normalText);
    }
  }
  .indicator.checkbox {
    border-radius: 10% !important;
    .activeCirc {
      border-radius: 10% !important;
      background-color: var(--normalText);
    }
  }
  .mainLabel {
    font-size: 20px;
    font-weight: bold;
    color: var(--normalText);
    text-align: right;
    line-height: 1;
  }
  .descLabel {
    font-size: 12px;
    font-weight: 200;
    color: var(--normalText);
    text-align: right;
    line-height: 1.6;
    margin-top: 4px;
  }
}
.radio.simpled {
  padding: 0;
  border: none;
  background-color: rgba($color: #000000, $alpha: 0) !important;
  .indicator {
    margin-left: 8px !important;
  }
  .mainLabel {
    padding: 4px !important;
    font-size: 14px !important;
  }
}
.radio.selected {
  opacity: 1;
  background-color: var(--themeGreen0);
  border-color: var(--themeGreen);
  .indicator {
    border-color: var(--themeGreen);
    .activeCirc {
      width: 8px;
      height: 8px;
    }
  }
}
.radio.deselected {
  opacity: 0.5;
  background-color: var(--normalText0);
  border-color: var(--normalText2);
  .indicator {
    border-color: var(--normalText2);
    .activeCirc {
      width: 0;
      height: 0;
    }
  }
  .mainLabel {
    font-weight: 300;
  }
}
.radio:hover {
  .indicator {
    box-shadow: 0 0 0 8px var(--normalText05);
  }
}
.radio.disable {
  pointer-events: none;
  opacity: 0.75;
}
.radio.noSlot {
  * {
    pointer-events: none;
  }
}
</style>
